import type { ReactNode } from 'react';

interface SectionProps {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}

export function Section({ title, children, action }: SectionProps) {
  return (
    <section className="work-card">
      <div className="work-card-title">
        <h2>{title}</h2>
        {action && <div>{action}</div>}
      </div>
      {children}
    </section>
  );
}
